import { Resolve } from 'vue-di';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { Mutation, Action } from 'vuex-module-decorators';
import { DiagnosisV3Api  } from '@trialcard/apigateway.client';
import { DiagnosisModel } from '@trialcard/apigateway.models';

@InjectModule({ stateFactory: true }, module)
export default class DiagnosisModule extends InjectVuexModule {
    @Resolve
    public diagnosisApi!: DiagnosisV3Api;

    programDiagnosis: DiagnosisModel[] = [];

    @Mutation
    public updateProgramDiagnosis(diagnosisList: DiagnosisModel[]) {
        this.programDiagnosis = diagnosisList;
    }

    @Mutation
    public clearProgramDiagnosis(diagnosisList: DiagnosisModel[]) {
        this.programDiagnosis = [];
    }

    @Action
    public async getProgramDiagnosis() {
        try {
            if (this.programDiagnosis.length === 0) {
                const getProgramDiagnosisResponse = await this.diagnosisApi.programDiagnosisGetByProgramId();
                const programDiagnosisList = getProgramDiagnosisResponse
                    && getProgramDiagnosisResponse.data
                    && getProgramDiagnosisResponse.data.data;
                if (programDiagnosisList) this.updateProgramDiagnosis(programDiagnosisList);
            }
            return;
        } catch(error) {
            console.log(error);
            return;
        }
    }
}
